/**
 * toolbarEdges — where the portrait toolbar's balance and bet text really end
 * (2026-10-15). The balance (left-aligned) reports its right edge, the bet
 * (right-aligned) its left edge, from the text as drawn — not the widest
 * possible value the toolbar reserves — and the win in between fits itself
 * to that gap (WinDisplay). null = not reported (not portrait).
 */
let edges = { balanceRight: null, betLeft: null };
const listeners = new Set();

export const setToolbarEdge = (key, value) => {
  const next = Number.isFinite(value) ? Math.round(value) : null;
  if (edges[key] === next) return;
  edges = { ...edges, [key]: next };
  listeners.forEach((listener) => listener());
};

export const subscribeToolbarEdges = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getToolbarEdges = () => edges;
